import UnblockProfileForm from '@/core/components/ProfileActions/UnblockProfileForm/UnblockProfileForm';

export default UnblockProfileForm;
